module.exports = __webpack_public_path__ + "static/media/baby.80cead1a.png";